import React from 'react';
import { cn } from '@/lib/utils';
import { getChatSafePageClasses } from '@/utils/layout';

interface PageShellProps {
  children: React.ReactNode;
  className?: string;
  includeChatPadding?: boolean;
  includeContainer?: boolean;
  includeHorizontalPadding?: boolean;
  includeAnimations?: boolean;
}

/**
 * PageShell - Always-visible page structure that renders immediately
 * This provides the base layout while content sections load progressively
 * 
 * Note: Mobile header top padding (pt-20/80px) is handled by UnifiedLayout's <main> element.
 * PageShell applies only BOTTOM padding (pb-6) via getChatSafePageClasses to avoid conflicts.
 * Chat bottom padding (md:pb-20) is also applied for floating chat clearance.
 */
export function PageShell({ 
  children, 
  className,
  includeChatPadding = true,
  includeContainer = true,
  includeHorizontalPadding = true,
  includeAnimations = true
}: PageShellProps) {
  const pageClasses = getChatSafePageClasses({
    includeContainer,
    includeHorizontalPadding,
    includeAnimations,
    customClasses: className
  });

  return (
    <div className={cn(pageClasses, "space-y-6")}>
      {children}
    </div>
  );
}